import type { SearchSuggestion } from '../view-models/search-suggestion';

export const isCategorySuggestion = (
    suggestion: SearchSuggestion | string
): suggestion is SearchSuggestion => {
    return typeof suggestion === 'object' && 'link' in suggestion;
};
